








import { defineComponent } from '@vue/composition-api';

const Treemap = defineComponent({
  props: {
    data: {},
  },
  setup() {
    const options = {
      responsive: false,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
    };

    return {
      options,
    };
  },
});

export default Treemap;
